"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContexteRegionalInvalide = void 0;
exports.creerFormateurRegional = creerFormateurRegional;
class ContexteRegionalInvalide extends Error {
    constructor(motif) {
        super(`Contexte régional invalide : ${motif}`);
        this.name = 'ContexteRegionalInvalide';
    }
}
exports.ContexteRegionalInvalide = ContexteRegionalInvalide;
function verifier(contexte) {
    if (!/^[A-Z]{2}$/.test(contexte.pays)) {
        throw new ContexteRegionalInvalide('le pays doit être ISO alpha-2 majuscule');
    }
    if (!/^[A-Z]{3}$/.test(contexte.devise)) {
        throw new ContexteRegionalInvalide('la devise doit être ISO alpha-3 majuscule');
    }
    if (!Number.isInteger(contexte.decimales) || contexte.decimales < 0 || contexte.decimales > 4) {
        throw new ContexteRegionalInvalide('les décimales doivent être un entier entre 0 et 4');
    }
    if (!Number.isInteger(contexte.pasArrondi) || contexte.pasArrondi <= 0) {
        throw new ContexteRegionalInvalide("le pas d'arrondi doit être un entier positif");
    }
    try {
        new Intl.DateTimeFormat(contexte.langue, { timeZone: contexte.fuseau }).format();
    }
    catch {
        throw new ContexteRegionalInvalide("le fuseau n'est pas un identifiant IANA reconnu");
    }
    // `Intl.Locale` n'existe pas dans Hermes (le moteur des apps). Comme `langue`
    // est déjà minuscule et `pays` validé en majuscules ci-dessus, la balise
    // `langue-PAYS` est déjà sous sa forme canonique — le constructeur ne faisait
    // que revalider ce que les regex garantissent.
    return `${contexte.langue}-${contexte.pays}`;
}
function dateValide(date) {
    const resultat = date instanceof Date ? date : new Date(date);
    if (!Number.isFinite(resultat.getTime())) {
        throw new RangeError("La date à formater n'est pas valide");
    }
    return resultat;
}
/**
 * Construit les formateurs depuis le pays et la langue. `Intl` décide des
 * séparateurs, de la place de la devise et de l'ordre calendaire — F-LNG-03.
 */
function creerFormateurRegional(contexte) {
    const locale = verifier(contexte);
    const formatMontant = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: contexte.devise,
        minimumFractionDigits: contexte.decimales,
        maximumFractionDigits: contexte.decimales,
    });
    return {
        montant(valeur) {
            if (!Number.isFinite(valeur))
                throw new RangeError("Le montant à formater n'est pas fini");
            const arrondi = Math.round(valeur / contexte.pasArrondi) * contexte.pasArrondi;
            return formatMontant.format(arrondi);
        },
        nombre(valeur, options) {
            if (!Number.isFinite(valeur))
                throw new RangeError("Le nombre à formater n'est pas fini");
            return new Intl.NumberFormat(locale, options).format(valeur);
        },
        date(valeur, options = { dateStyle: 'medium' }) {
            return new Intl.DateTimeFormat(locale, {
                ...options,
                timeZone: contexte.fuseau,
            }).format(dateValide(valeur));
        },
        heure(valeur, options = { timeStyle: 'short' }) {
            return new Intl.DateTimeFormat(locale, {
                ...options,
                timeZone: contexte.fuseau,
            }).format(dateValide(valeur));
        },
    };
}
//# sourceMappingURL=formatage.js.map